import { whatIsPadel } from "./posts/what-is-padel";
import { padelVsPickleball } from "./posts/padel-vs-pickleball";
import { tennisDoublesHandSignals } from "./posts/tennis-doubles-hand-signals";
import { tennisServeBreaksDownInMatches } from "./posts/tennis-serve-breaks-down-in-matches";
import { padelNetRules } from "./posts/padel-net-rules";
import { tennisLetRules } from "./posts/tennis-let-rules";
import { canYouCallYourOwnFirstServeOut } from "./posts/can-you-call-your-own-first-serve-out";
import { padelReturnOfServeRules } from "./posts/padel-return-of-serve-rules";
import { tennisDoublesTiebreakServingOrder } from "./posts/tennis-doubles-tiebreak-serving-order";
import { padelServeRules } from "./posts/padel-serve-rules";
import { padelScoringRulesGuide } from "./posts/padel-scoring-rules-guide";
import { improveTennisGameTrackingStats } from "./posts/improve-tennis-game-tracking-stats";
import { padelBandejaVsVibora } from "./posts/padel-bandeja-vs-vibora";
import { padelGlassDefense } from "./posts/padel-glass-defense";
import { tennisReturnStrategy } from "./posts/tennis-return-strategy";
import { tennisSinglesVsDoubles } from "./posts/tennis-singles-vs-doubles";
import { howToUseRacketly } from "./posts/how-to-use-racketly";
import { calvoFernandezLondonP1Upset } from "./posts/calvo-fernandez-london-p1-upset";
import { triayBreaPretoriaP1Champions } from "./posts/triay-brea-pretoria-p1-champions";
import { padelMediterraneanGamesDebut } from "./posts/padel-mediterranean-games-debut";
import { swiatekTorontoTitleComeback } from "./posts/swiatek-toronto-title-comeback";

export const blogPosts = [
  whatIsPadel,
  padelVsPickleball,
  tennisDoublesHandSignals,
  tennisServeBreaksDownInMatches,
  padelNetRules,
  tennisLetRules,
  canYouCallYourOwnFirstServeOut,
  padelReturnOfServeRules,
  tennisDoublesTiebreakServingOrder,
  padelServeRules,
  calvoFernandezLondonP1Upset,
  triayBreaPretoriaP1Champions,
  padelMediterraneanGamesDebut,
  swiatekTorontoTitleComeback,
  padelScoringRulesGuide,
  improveTennisGameTrackingStats,
  padelBandejaVsVibora,
  padelGlassDefense,
  tennisReturnStrategy,
  tennisSinglesVsDoubles,
  howToUseRacketly,
];
